import React, { useContext } from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
//Srcs
import "./setting.scss";

import ExpenseType from "../Assets/finance.png";
// import GradeIcon from "../Assets/exam.png";
import GradeIcon from "../Assets/grade.png";
import ExpenseGroup from "../Assets/budget (1).png";
import User from "../Assets/customer.png";
import Supplier from "../Assets/supplier.png";
import GroupFee from "../Assets/gruop-fee.png";
import IncomeHead from "../Assets/head-income.png";
import customerService from "../Assets/customer-service.png";
import purchaseOrder from "../Assets/purchase-order.png";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";


export default function Setting() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  return (
    <div className="setting-page">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">{t("page_setting")}</Typography>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              {t("page_setting")}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ mt: "30px" }}>
        <Grid container spacing={4}>
          {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/setting/exspense-group"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseGroup} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      {t("thead_set_up_expense_group")}
                    </Typography>
                    <Typography className="page-description">
                      {t("thead_define_exspense_group")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid> */}

          {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/setting/exspense-type"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseType} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      {t("thead_set_up_expense_type")}
                    </Typography>
                    <Typography className="page-description">
                      {t("thead_define_exspense_type")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid> */}

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link
              to="/setting/chart-of-account"
              style={{ textDecoration: "none" }}
            >
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={ExpenseType} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Chart of account
                    </Typography>
                    <Typography className="page-description">
                      {t("thead_define_exspense_type")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/users" style={{ textDecoration: "none" }}>
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={User} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      {t("thead_set_up_user")}
                    </Typography>
                    <Typography className="page-description">
                      {t("thead_define_user")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/supplier" style={{ textDecoration: "none" }}>
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={customerService} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      {t("thead_set_up_supplier")}
                    </Typography>
                    <Typography className="page-description">
                      {t("thead_define_supplier")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/gruop-fee" style={{ textDecoration: "none" }}>
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={GroupFee} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      {t("thead_set_up_group_fee")}
                    </Typography>
                    <Typography className="page-description">
                      {t("thead_define_group_fee")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/fee" style={{ textDecoration: "none" }}>
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={GroupFee} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">Set up fee</Typography>
                    <Typography className="page-description">
                      To define fee
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid> */}

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/head-income" style={{ textDecoration: "none" }}>
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={IncomeHead} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Set Up Income Head
                    </Typography>
                    <Typography className="page-description">
                      To define income head
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>


          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/list-item" style={{ textDecoration: "none" }}>
              <Stack
                direction="row"
                spacing={3}
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={purchaseOrder} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Set Up List Item
                    </Typography>
                    <Typography className="page-description">
                      To define list item
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>


          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/setting/customer" style={{ textDecoration: "none" }}>
              <Stack
                spacing={3}
                direction="row"
                className="setting-page-container"
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  className="page-image"
                >
                  <img alt="Exam icon" className="image" src={Supplier} />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Stack direction="column">
                    <Typography className="page-title">
                      Set Up Customer
                    </Typography>
                    <Typography className="page-description">
                      To define customer
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Link>
          </Grid>


        </Grid>
      </Box>
    </div>
  );
}
